<template>
  <scenic-spot :value.sync="scenicSpot"/>
</template>
<script>
import {reactive} from 'vue'
import ScenicSpot from './ScenicSpot'

export default {
  components: {ScenicSpot},
  setup() {
    const scenicSpot = reactive({
      location: '',
      name: '',
      pictures: [],
      description: '',
      division: [],
      division_detail: '',
      isHot: false,
      needBooking: false,
      maxBookingCount: 5
    })


    return {
      scenicSpot,
      log: console.log
    }
  }
}
</script>
